import React, { useEffect, useState } from "react";
import axios from "../../api/axios";
import apiUrl from "../../api/config.json";
import "./TrailerModal.css";

const API_KEY = apiUrl.APIKey;

function TrailerModal({ movieId, onClose }) {
	const [trailerKey, setTrailerKey] = useState(null);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState("");

	useEffect(() => {
		if (!movieId) return;

		async function fetchTrailer() {
			setLoading(true);
			setError("");
			try {
				const res = await axios.get(
					`/movie/${movieId}/videos?api_key=${API_KEY}&language=en-US`
				);
				const trailer = res.data.results.find(
					(r) => r.type === "Trailer" && r.site === "YouTube"
				) || res.data.results.find((r) => r.site === "YouTube");
				if (trailer) {
					setTrailerKey(trailer.key);
				} else {
					setError("No trailer available");
				}
			} catch {
				try {
					const res = await axios.get(
						`/tv/${movieId}/videos?api_key=${API_KEY}&language=en-US`
					);
					const trailer = res.data.results.find(
						(r) => r.type === "Trailer" && r.site === "YouTube"
					) || res.data.results.find((r) => r.site === "YouTube");
					if (trailer) {
						setTrailerKey(trailer.key);
					} else {
						setError("No trailer available");
					}
				} catch {
					setError("Failed to load trailer");
				}
			} finally {
				setLoading(false);
			}
		}
		fetchTrailer();
	}, [movieId]);

	// Close on Escape key
	useEffect(() => {
		const handleKey = (e) => {
			if (e.key === "Escape") onClose();
		};
		document.addEventListener("keydown", handleKey);
		return () => document.removeEventListener("keydown", handleKey);
	}, [onClose]);

	// Prevent body scroll
	useEffect(() => {
		document.body.style.overflow = "hidden";
		return () => {
			document.body.style.overflow = "";
		};
	}, []);

	return (
		<div className="trailer-modal__backdrop" onClick={onClose}>
			<div className="trailer-modal__container" onClick={(e) => e.stopPropagation()}>
				<button className="trailer-modal__close" onClick={onClose} aria-label="Close">
					&times;
				</button>
				<div className="trailer-modal__player">
					{loading && (
						<div className="trailer-modal__loading">Loading trailer...</div>
					)}
					{!loading && error && (
						<div className="trailer-modal__error">{error}</div>
					)}
					{!loading && trailerKey && (
						<iframe
							src={`https://www.youtube.com/embed/${trailerKey}?autoplay=1&rel=0&modestbranding=1`}
							title="Trailer"
							allow="autoplay; encrypted-media"
							allowFullScreen
						/>
					)}
				</div>
			</div>
		</div>
	);
}

export default TrailerModal;
